import { OperationDto } from './OperationDto';
import { OperationStatus } from '../../domain/entities';
import { Operation } from '../../domain/entities/Operation';

export const toDomain = (dto: OperationDto): Operation =>
    new Operation(OperationStatus[dto.status as keyof typeof OperationStatus]);
